// extracted by mini-css-extract-plugin
export default {"wideFlex":"Directory_wideFlex__o4a21","contents":"Directory_contents__-agI1","member_card":"Directory_member_card__k9Wp5","email_badge":"Directory_email_badge__iH6vE"};